import { gql } from "@apollo/client";

export const ADD_AUDIO_RECORDING = gql`
  mutation addAudioRecording($addRecording: AddAudioRecording!) {
    addAudioRecording(addRecording: $addRecording)
  }
`;
